var ReflectUtils;
((ReflectUtils2) => {
  ReflectUtils2.getParameterTypes = (target, propertyKey) => {
    if (propertyKey) {
      return Reflect.getMetadata("design:paramtypes", target, propertyKey) || [];
    } else {
      return Reflect.getMetadata("design:paramtypes", target) || [];
    }
  };
  ReflectUtils2.getReturnType = (target, propertyKey) => {
    return Reflect.getMetadata("design:returntype", target, propertyKey);
  };
  ReflectUtils2.getType = (target, propertyKey) => {
    if (propertyKey) {
      return Reflect.getMetadata("design:type", target, propertyKey);
    } else {
      return Reflect.getMetadata("design:type", target);
    }
  };
  ReflectUtils2.getMetadata = (metadataKey, target, propertyKey) => {
    if (propertyKey) {
      return Reflect.getMetadata(metadataKey, target, propertyKey);
    } else {
      return Reflect.getMetadata(metadataKey, target);
    }
  };
  ReflectUtils2.findMetadata = (metadataKey, target, propertyKey) => {
    if (target == null) return void 0;
    let searchTarget = typeof target === "object" && typeof target !== "function" ? target.constructor : target;
    const seen = /* @__PURE__ */ new Set();
    while (searchTarget && searchTarget !== Object && !seen.has(searchTarget)) {
      seen.add(searchTarget);
      const data = propertyKey ? Reflect.getOwnMetadata(metadataKey, searchTarget, propertyKey) : Reflect.getOwnMetadata(metadataKey, searchTarget);
      if (data !== void 0) return data;
      const proto = Object.getPrototypeOf(searchTarget);
      searchTarget = proto && typeof proto === "function" ? proto : proto?.constructor || null;
    }
    return void 0;
  };
  ReflectUtils2.findAllMetadata = (metadataKey, target, propertyKey) => {
    const results = [];
    if (target == null) return results;
    let searchTarget = typeof target === "object" && typeof target !== "function" ? target.constructor : target;
    const seen = /* @__PURE__ */ new Set();
    while (searchTarget && searchTarget !== Object && !seen.has(searchTarget)) {
      seen.add(searchTarget);
      const data = propertyKey ? Reflect.getOwnMetadata(metadataKey, searchTarget, propertyKey) : Reflect.getOwnMetadata(metadataKey, searchTarget);
      if (data !== void 0) results.unshift(data);
      const proto = Object.getPrototypeOf(searchTarget);
      searchTarget = proto && typeof proto === "function" ? proto : proto?.constructor || null;
    }
    return results;
  };
  ReflectUtils2.findAllMetadataFlatten = (metadataKey, target, propertyKey) => {
    const results = [];
    const metaList = (0, ReflectUtils2.findAllMetadata)(metadataKey, target, propertyKey);
    metaList.forEach((data) => {
      if (Array.isArray(data)) results.push(...data);
    });
    return [...new Set(results)];
  };
  ReflectUtils2.findAllMapMetadata = (metadataKey, target) => {
    const finalMap = /* @__PURE__ */ new Map();
    const metaList = (0, ReflectUtils2.findAllMetadata)(metadataKey, target);
    metaList.forEach((data) => {
      if (data instanceof Map) {
        data.forEach((values, key) => {
          if (!finalMap.has(key)) finalMap.set(key, []);
          const valArr = Array.isArray(values) ? values : [values];
          finalMap.get(key).push(...valArr);
        });
      }
    });
    return finalMap;
  };
  ReflectUtils2.getMetadataKeys = (target) => {
    return Reflect.getMetadataKeys(target);
  };
  ReflectUtils2.getOwnMetadata = (metadataKey, target, propertyKey) => {
    if (propertyKey) {
      return Reflect.getOwnMetadata(metadataKey, target, propertyKey);
    } else {
      return Reflect.getOwnMetadata(metadataKey, target);
    }
  };
  ReflectUtils2.getMetadatas = (target) => {
    return (0, ReflectUtils2.getMetadataKeys)(target).map((it) => (0, ReflectUtils2.getMetadata)(it, target));
  };
  ReflectUtils2.metadata = (metadataKey, data) => {
    return Reflect.metadata(metadataKey, data);
  };
  ReflectUtils2.defineMetadata = (metadataKey, value, target, propertyKey) => {
    if (propertyKey && Reflect.defineMetadata) {
      Reflect.defineMetadata(metadataKey, value, target, propertyKey);
    } else if (Reflect.defineMetadata) {
      Reflect.defineMetadata(metadataKey, value, target);
    }
  };
  ReflectUtils2.copyMetadata = (from, to, propertyKey) => {
    const keys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
    for (const key of keys) {
      const data = propertyKey ? Reflect.getOwnMetadata(key, from, propertyKey) : Reflect.getOwnMetadata(key, from);
      if (propertyKey) {
        Reflect.defineMetadata(key, data, to, propertyKey);
      } else {
        Reflect.defineMetadata(key, data, to);
      }
    }
  };
})(ReflectUtils || (ReflectUtils = {}));
export {
  ReflectUtils
};
//# sourceMappingURL=ReflectUtils.js.map
